export const regular = {
  // 身份证号码,包括15位和18位的
  IDCard: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
  IDCardMsg: "请输入正确的身份证号码",
  //手机号码
  phone: /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])[0-9]{8}$/,
  phoneMsg: "请输入正确的手机号码",
  //邮箱地址
  email: /(^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(.[a-zA-Z0-9-]+)*.[a-zA-Z0-9]{2,6}$)/,
  emailMsg: "请输入正确格式的邮箱地址",
  // 0到20位的英文字符和数字
  enNum0to20: /^[a-z0-9A-Z]{0,20}$/,
  enNum0to20Msg: "请输入20位以内的英文字符和数字",
  // 特殊字符
  specialChar: /^[^`~!@#$^&*()=|{}':;',/\\[\].<>?]*$/,
  specialCharMsg: "请删除特殊字符",
  // 保留两位小数^[0-9]+(.[0-9]{0,2})?$
  twoDecimal: /^(([0-9][0-9]*)|(([0]\.\d{1,2}|[0-9][0-9]*\.\d{1,2})))$/,
  twoDecimalMsg: "请输入小数点后最多两位的数字",
  // 保留三位小数^[0-9]+(.[0-9]{0,3})?$
  threeDecimal: /^(([0-9][0-9]*)|(([0]\.\d{1,3}|[0-9][0-9]*\.\d{1,3})))$/,
  threeDecimalMsg: "请输入小数点后最多三位的数字",
  //正整数
  num: /^[0-9]*[1-9][0-9]*$/,
  numMsg: "请输入正整数",
  //经度值校验
  longitude: /^(-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,6})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,6}|180)$/,
  longitudeMsg: "请输入正确的经度值且最多保留六位小数",
  //纬度校验
  latitude: /^(-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/,
  latitudeMsg: "请输入正确的纬度值且最多保留六位小数",
  //车架号
  vin: /^[A-HJ-NPR-Z\d]{17}$/,
  vinMsg: "请输入正确的车架号",
  //ICCID
  iccid: /^\d{20}$/,
  iccidMsg: "请输入正确的ICCID",
  //非汉字
  noChinese: /^[^\u4e00-\u9fa5]{0,}$/,
  noChineseMsg: "请勿输入中文",
  // 非负、小数验证
  non_negative: /^\+?(:?(:?\d+\.\d+)|(:?\d+))$/,
  non_negativeMsg: "请输入正确的数字",
}
